import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import {
  provideClinicianApi,
  provideTeleEngine,
  TeleEngineEnvironment,
} from '@shareview-health/clinician/shared';
import {
  provideShareViewAuthorization,
  provideShareViewInterceptors,
} from '@shareview-health/shared';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(appRoutes),
    provideShareViewAuthorization({
      issuer: environment.authorization.issuer,
      clientId: environment.authorization.clientId,
      scope: environment.authorization.scope,
      secureRoutes: [environment.apiBaseUrl],
    }),
    provideShareViewInterceptors(),
    provideClinicianApi(environment.apiBaseUrl, environment.signalR.hubPath),
    provideTeleEngine(environment.teleEngine.environment as TeleEngineEnvironment),
  ],
};
